<kort id="aksjeklasser" #kort>
  <kort-tittel>
    {{ 'Aksjeklasser' | translate }}
    <div class="antall">{{ '{antall} aksjeklasser' | translate: {antall: aktiveKlasser().length} }}</div>
  </kort-tittel>

  @if (visning()) {
    @if (!kort.erAktiv()) {
      <p>{{ 'Aksjonærers beholdning kan knyttes til aksjeklasser. Typiske aksjeklasser er A og B.' | translate }}</p>
      <kort-handlinger>
        <button mat-button (click)="visDetaljer()" data-testid="vis-alle-knapp">
          <mat-icon>list</mat-icon>
          {{ 'Vis alle' | translate }}
        </button>
      </kort-handlinger>

    } @else {
      <div class="innhold-kontainer">
        <table>
          <thead>
          <tr>
            <th>{{ 'Klasse' | translate }}</th>
            <th>{{ 'I bruk' | translate }}</th>
          </tr>
          </thead>
          <tbody>
            @for (klasse of aktiveKlasser(); track klasse.id) {
              <tr>
                <td>
                  <div class="tittel">{{ klasse.navn }}</div>
                  @if (klasse.beskrivelse) {
                    <html-formatert [innhold]="klasse.beskrivelse" class="beskrivelse"/>
                  }
                </td>
                <td>
                  <mat-icon>{{ klasse.iBrukIBeholdning ? 'check_circle' : 'circle' }}</mat-icon>
                </td>
              </tr>
            }
            <tr>
              <td colspan="2" class="arkiverte-lenke">
                @if (viserArkiverteKlasser()) {
                  <a (click)="viserArkiverteKlasser.set(false)">
                    {{ 'Skjul arkiverte aksjeklasser' | translate }}
                  </a>
                } @else {
                  <a (click)="viserArkiverteKlasser.set(true)" data-testid="vis-arkiverte-knapp">
                    {{ 'Vis {antall} arkiverte aksjeklasser' | translate: {antall: arkiverteKlasser().length} }}
                  </a>
                }
              </td>
            </tr>
          </tbody>

          @if (viserArkiverteKlasser()) {
            <tbody class="arkiverte-klasser">
              @for (klasse of arkiverteKlasser(); track klasse.id) {
                <tr>
                  <td>
                    <div class="tittel">{{ klasse.navn }}</div>
                    @if (klasse.beskrivelse) {
                      <html-formatert [innhold]="klasse.beskrivelse" class="beskrivelse"/>
                    }
                  </td>
                  <td>
                    <mat-icon>{{ klasse.iBrukIBeholdning ? 'check_circle' : 'circle' }}</mat-icon>
                  </td>
                </tr>
              }
            </tbody>
          }
        </table>
      </div>
      <kort-handlinger>
        <button mat-button (click)="skjulDetaljer()">{{ 'Skjul' | translate }}</button>
        <button mat-button (click)="rediger()" data-testid="rediger-knapp">
          <mat-icon>edit</mat-icon>
          {{ 'Rediger' | translate }}
        </button>
      </kort-handlinger>
    }

  } @else {
    <aksjeklasse-rediger-liste
        [aksjeklasser]="aksjeklasser()"
        [aksjeeierbokId]="aksjeeierbokId()"
        (vedFerdig)="redigeringFerdig($event)"/>
  }
</kort>
